import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'

import { tryToRegister } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import CustomField from '../CustomField/CustomField.js'
import CustomSelect from '../CustomSelect/CustomSelect.js'

import './RegisterForm.css';


const getUrlParams = () => {
  var urlParams;
  var match,
      pl     = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
      query  = window.location.search.substring(1);

  urlParams = {};
  while (match = search.exec(query))
     urlParams[decode(match[1])] = decode(match[2]);

  return urlParams;
}


class RegisterForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      agree_check: false,
      display_name: props.user.registerForm.lastSubmit.display_name,
      email: props.user.registerForm.lastSubmit.email,
      password: props.user.registerForm.lastSubmit.password,
      howd_you_find_us: undefined,
      referalOptions: [
        {
          label: 'Friend',
          value: 'friend'
        },
        {
          label: 'Forum Post',
          value: 'forum'
        },
        {
          label: 'School / Professor',
          value: 'school_or_professor'
        },
        {
          label: 'Colleague',
          value: 'colleague'
        },
        {
          label: 'Searching for patterns',
          value: 'searching_for_patterns'
        },
        {
          label: 'Searching for tools or editing capabilities',
          value: 'searching_for_tools'
        },
        {
          label: 'Searching for cake recipes',
          value: 'searching_for_recipes'
        },
        {
          label: 'Other',
          value: 'other'
        }
      ]
    }

    this.toggleCheck = this.toggleCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleSubmit(e){
    const { dispatch } = this.props; 

    if(this.state.agree_check){
      dispatch(tryToRegister({
        display_name: this.state.display_name,
        email: this.state.email,
        password: this.state.password,
        howd_you_find_us: this.state.howd_you_find_us || "no_answer"
      }));
    }
    if(e) e.preventDefault();
  }

  toggleCheck(){
    var c = this.state.agree_check;
    this.setState({
      agree_check: c ? false : true
    })
  }

  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    var urlParams = getUrlParams();

    let formDisabled = (!this.state.agree_check || this.state.email == '' || this.state.password == '' || this.state.display_name == '');

    return (
      <div className="register-form">

        <form name="RegisterForm" onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleSubmit(e);
        }}>

          <CustomField 
            type="text"
            name="display_name"
            placeholder="Jane Smith"
            label="Name"
            value={this.state.display_name}
            onChange={(e) => {this.setState({display_name: e}); }}
            serverErrors={user.registerForm.errors.display_name}
            required={true}
            disabled={user.tryingToRegister}
          />
          <CustomField 
            type="text"
            regex="email"
            name="email"
            placeholder="email address"
            label="Email Address"
            value={this.state.email}
            onChange={(e) => {this.setState({email: e}); }}
            serverErrors={user.registerForm.errors.email}
            required={true}
            disabled={user.tryingToRegister}
          />
          
          <CustomField 
            type="password"
            name="password"
            placeholder="password"
            label="Password"
            value={this.state.password}
            onChange={(e) => {this.setState({password: e}); }}
            serverErrors={user.registerForm.errors.password}
            required={true}
            minLength={8}
            disabled={user.tryingToRegister}
          />

          <CustomSelect
            name="referal"
            label="Referal Source (optional)"
            options={this.state.referalOptions}
            value={this.state.howd_you_find_us}
            onChange={(v)=>{ this.setState({howd_you_find_us: v})}}
            placeholder="How'd you find us?"
            />

          <div className="agree-wrapper">
            <div className="agree-check">
              <Checkbox value={this.state.agree_check} onToggle={this.toggleCheck}/>
            </div>
            <div className="agree-text">
              I accept the <Link to="/tos" target="_blank" rel="noopener noreferrer">Terms</Link> and <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>.
            </div>
          </div>
          <div className="text-center">
            
            <Button 
              submit={true} 
              block={true}
              thinking={user.tryingToRegister} 
              successful={user.successfullyRegistered}
              failed={user.failedToRegister}
              display="Sign Up for Free" 
              size="large" 
              color="success" 
              disabled={formDisabled}
            />
          </div>
          <div className="agree-wrapper">
            <div className="agree-text">
              <Link to={"/login" + (urlParams.after ? "?after=" + urlParams.after : "")}>I already have an account<i className="far fa-angle-right fa-fw"/></Link>
            </div>
          </div>
        </form>
      </div>
    )
  }
}



RegisterForm = reduxForm({
  form: 'RegisterForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(RegisterForm)

RegisterForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    initialValues
  }
})(RegisterForm);

export default RegisterForm;



// WEBPACK FOOTER //
// ./src/components/RegisterForm/RegisterForm.js